import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 21H13V15H21V21ZM11 21H3V11H11V21ZM21 13H13V3H21V13ZM11 9H3V3H11V9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dashboard"
);
